import React, { Component, Fragment } from 'react';
import { withRouter } from "react-router-dom";
import { Accordion, Card } from "react-bootstrap";

import InputMask from "react-input-mask";
import moment from "moment";

import TaContext from './TaContext';
import { SpaceBox } from "../../components/Space";
import SelectComponent from "../../components/Select";
import ProvincesComponent from "../../components/Provinces";
import DatePickerComponent from "../../components/Datepicker";
import NameThComponent from "../../components/Customer/NameTh";
import NameEngComponent from "../../components/Customer/NameEng";

import DataService from "../../service/data";
import { DateUtils, Alert } from "../../utils";
import { Step3Langague } from "../../data/locale";
import { RELATIONS, RELATIONS_EN } from "../../data/global";
import { DATETIME_SEARCH_FORMAT } from "../../const";

import UserIcon from "../../images/user_icon.svg";
import AddRound from "../../images/add_round.svg";
import DelRound from "../../images/del_round.svg";
import ChevonDown from "../../images/chevron-down.svg";

const imgScale = {
  width: "24px",
  height: "24px",
};
const MaskOptions = {
  mask: "********************",
  maskChar: "",
  formatChars: {
    "*": "[a-zA-Z0-9]",
  },
};

const Icon = (props) => (
  <img className={props.className} src={props.src} {...imgScale} />
);

 class Step3 extends Component {
  state = {
    benefitTitles: [],
    benefitTitlesEN: [],
    nationals: [],
  };
  titles = [];

  constructor(props) {
    super(props);
    setTimeout(() => {
      this.initData();
    }, 100);
  }

  async initData() {
    try {
      const callers = [];
      callers.push(DataService.getTitle({ lang: "", type: "B" }));
      callers.push(DataService.getNationalities());
      callers.push(DataService.getOccupations());

      const responses = await Promise.all(callers);
      this.titles = responses[0];
      const benefitTitles = this.titles.filter((data) => data.lang === "TH");
      const benefitTitlesEN = this.titles.filter((data) => data.lang === "EN");

      this.setState({
        ...this.state,
        benefitTitles: benefitTitles,
        benefitTitlesEN: benefitTitlesEN,
        nationals: responses[1],
        occupations: responses[2],
      });
    } catch (err) {
      console.log(err);
    }
  }
  _getTitles(sSex, lang) {
    return this.titles.filter(
      (title) => title.gender === sSex && title.lang === lang
    );
  }

  _getLang(field) {
    const lang = this.context.step1.langague === 2 ? "en" : "th";
    return Step3Langague[field][lang];
  }

  _getCustomLang(field, lang) {

    return Step3Langague[field][lang];
  }
  
  _renderPresonForm(key) {
    const { insures, onChangeModel, onChangeNationality } =
      this.context.step3 || {};
    const {
      sNationality,
      sIDNo = "",
      sPassportNo = "",
      sExpiryDate = "",
      sSex,
      sInitNameTH = "",
      sFirstNameTH = "",
      sLastNameTH = "",
      sInitNameEN = "",
      sFirstNameEN = "",
      sLastNameEN = "",
      sBirthDate = "",
      sOccupation = "",
      sMobile = "",
      sEmail = "",
    } = insures[key];

    const isThai = sNationality && sNationality.value === "THA";
    const lang = isThai ? 'th' : 'en';

    const today = DateUtils.getCurrentTh("YYYY-MM-DD");
    const maxDate = new Date(
      moment(today).subtract(1, "years").endOf('years').format(DATETIME_SEARCH_FORMAT)
    );
    const minDate = new Date(
      moment(today).subtract(70, "years").startOf('years').format(DATETIME_SEARCH_FORMAT)
    );
    const minExpiryDate = new Date(
      moment(today).add(6, "months").format(DATETIME_SEARCH_FORMAT)
    );
    const maxExpiryDate = new Date(
      moment(today).add(11, "years").format(DATETIME_SEARCH_FORMAT)
    );
    const diffDate = sBirthDate
      ? moment.utc().diff(moment(sBirthDate), "years")
      : "-";

    return (
      <>
        <div className="form-group">
          <label>{this._getLang("nationality")}</label>
          <SelectComponent
            placeholder="สัญชาติ"
            options={this.state.nationals}
            selected={sNationality}
            onChange={(selected) => {
              if(sNationality && selected &&
                sNationality.value != selected.value) {
                
                onChangeNationality({
                  key,
                  name: "sNationality",
                  value: selected,
                })

                const langChange = selected.value == 'THA' ? 'th' : 'en';
                if(langChange != lang) {
                  if(insures[key].benefits) {
                    const benefits = insures[key].benefits;
                    for(let benefit of benefits)
                    {
                      benefit.sRelation = "";
                      benefit.sInit = "";
                    }
                    onChangeModel({ key, name: "benefits", value: benefits})
                  }
                }
                }
            }}
          />
        </div>
        <div className="form-group">
          {sNationality && sNationality.value === "THA" ? (
            <>
              <label>{this._getLang("identity")}</label>
              <InputMask
                mask="9-9999-99999-99-9"
                maskChar="_"
                type="tel"
                value={sIDNo}
                onChange={(e) =>
                  onChangeModel({
                    key,
                    name: e.target.name,
                    value: e.target.value,
                  })
                }
              >
                {(inputProps) => (
                  <input
                    id={`sIDNo_${key}`}
                    {...inputProps}
                    className="form-control"
                    placeholder={this._getLang("identityPlaceHolder")}
                    name="sIDNo"
                  />
                )}
              </InputMask>
            </>
          ) : (
              <>
                <label>{this._getLang("other_identity")}</label>
                <InputMask
                  // mask="9-9999-99999-99-9"
                  // maskChar="_"
                  {...MaskOptions}
                  type="text"
                  value={sPassportNo}
                  onChange={(e) =>
                    onChangeModel({
                      key,
                      name: e.target.name,
                      value: e.target.value,
                    })
                  }
                >
                  {(inputProps) => (
                    <input
                      id={`sPassportNo_${key}`}
                      {...inputProps}
                      className="form-control"
                      placeholder={this._getLang("other_identityPlaceHolder")}
                      name="sPassportNo"
                    />
                  )}
                </InputMask>
                <div className="form-group mt-2">
                  <DatePickerComponent
                    selected={sExpiryDate ? new Date(sExpiryDate) : ""} // ? new Date(sExpiryDate) : ""
                    minDate={new Date()}
                    // minDate={minExpiryDate}
                    // maxDate={maxExpiryDate}
                    // datePrevious={60}
                    placeholderText={this._getLang("expiredDate")}
                    onChange={(date) => {
                        if(moment(date).isBefore(moment(minExpiryDate))) {
                          Alert.alertWithTitle("ประกันเดินทางต่างประเทศ Happy Trip", "พาสปอร์ตต้องมีอายุไม่น้อยกว่า 6 เดือน นับตั้งแต่ปัจจุบัน", "warning");
                          onChangeModel({ key, name: "sExpiryDate", value: "" })
                        } else {
                          onChangeModel({ key, name: "sExpiryDate", value: date })
                        }
                      }
                    }
                    dateFormat="dd/MM/yyyy"
                    showTimeSelect={false}
                    showMonthYearDropdown
                    popperPlacement="top-start"
                  />
                  <p className="text-helper text-small">พาสปอร์ตต้องมีอายุไม่น้อยกว่า 6 เดือน นับตั้งแต่ปัจจุบัน</p>
                </div>
              </>
            )}
        </div>
        <div className="form-group">
          <label>{this._getLang("gender")}</label>
          <div className="d-flex">
            <div
              className={`radio-button align-item-center ${
                sSex === "M" ? "active" : ""
                }`}
              onClick={() => onChangeModel({ key, name: "sSex", value: "M" })}
            >
              <div className="radio" />
              <p>{this._getLang("male")}</p>
            </div>
            <div
              className={`radio-button align-item-center ${
                sSex === "F" ? "active" : ""
                }`}
              onClick={() => onChangeModel({ key, name: "sSex", value: "F" })}
            >
              <div className="radio" />
              <p>{this._getLang("female")}</p>
            </div>
          </div>
        </div>

        {sNationality && sNationality.value === "THA" && (
          <NameThComponent
            keyIndex={key}
            titles={this._getTitles(sSex, "TH")}
            sInitNameTH={sInitNameTH}
            sFirstNameTH={sFirstNameTH}
            sLastNameTH={sLastNameTH}
            labelLang={this.context.step1.langague}
            onChange={onChangeModel}
          />)
        }
        <NameEngComponent
          keyIndex={key}
          titles={this._getTitles(sSex, "EN")}
          sInitNameEN={sInitNameEN}
          sFirstNameEN={sFirstNameEN}
          sLastNameEN={sLastNameEN}
          labelLang={this.context.step1.langague}
          onChange={onChangeModel}
        />
        <div className="form-group">
          <div className="d-flex">
            <label>{this._getLang("birthdate")}</label>
            <div className="ml-auto">
              <p className="text-dark-blue">
                <b>{diffDate}</b> ปี
              </p>
            </div>
          </div>
          <DatePickerComponent
            selected={sBirthDate ? new Date(sBirthDate) : ""}
            minDate={minDate}
            maxDate={maxDate}
            datePrevious={70}
            placeholderText={this._getLang("birthdate")}
            onChange={(date) =>
              onChangeModel({ key, name: "sBirthDate", value: date })
            }
            dateFormat="dd/MM/yyyy"
            showTimeSelect={false}
            showMonthYearDropdown
            popperPlacement="top-start"
          />
        </div>
        <div className="form-group">
          <label>{this._getLang("contact")}</label>
          <InputMask
            mask="9999999999"
            type="tel"
            value={sMobile}
            onChange={(e) =>
              onChangeModel({ key, name: e.target.name, value: e.target.value })
            }
          >
            {(inputProps) => (
              <input
                id={`sMobile_${key}`}
                {...inputProps}
                className="form-control"
                placeholder={this._getLang("contactPlaceHolder")}
                name="sMobile"
              />
            )}
          </InputMask> 
        </div>
        <div className="form-group">
          <label>{this._getLang("email")}</label>
          <input
            id={`sEmail_${key}`}
            type="text"
            className="form-control"
            placeholder="name@email.com"
            name="sEmail"
            value={sEmail}
            onChange={(e) =>
              onChangeModel({ key, name: e.target.name, value: e.target.value })
            }
          />
        </div>
      </>
    );
  }

  _renderAddressForm(key) {
    const { insures, onChangeModel, onChangeModelProvinces } =
      this.context.step3 || {};
      const lang = this.context.step1.langague === 2 ? "en" : "th";
    const {
      sNo,
      sMoo,
      sSoi,
      sRoad,
      sProvince,
      sDistrict,
      sCity,
      sZipcode,
      sBuilding
    } = insures[key];
    return (
      <>
        <div className="form-group d-flex">
          <input
            id={`sNo_${key}`}
            type="text"
            className="form-control"
            placeholder={this._getLang("no")}
            name="sNo"
            value={sNo}
            onChange={(e) =>
              onChangeModel({ key, name: e.target.name, value: e.target.value })
            }
          />
          {this._SpaceBox()}
          <input
            id={`sMoo_${key}`}
            type="text"
            className="form-control"
            placeholder={this._getLang("moo")}
            name="sMoo"
            value={sMoo}
            onChange={(e) =>
              onChangeModel({ key, name: e.target.name, value: e.target.value })
            }
          />
        </div>
        {this._SpaceBox()}
        <div className="form-group d-flex">
          <input
            // id={sMoo}
            id={`sBuilding_${key}`}
            type="text"
            className="form-control"
            placeholder={this._getLang("buildingVillage")}
            name="sBuilding"
            value={sBuilding}
            onChange={(e) =>
              onChangeModel({ key, name: e.target.name, value: e.target.value })
            }
          />
        </div>
        <div className="form-group d-flex">
          <input
            id={`sSoi_${key}`}
            type="text"
            className="form-control"
            placeholder={this._getLang("soi")}
            name="sSoi"
            value={sSoi}
            onChange={(e) =>
              onChangeModel({ key, name: e.target.name, value: e.target.value })
            }
          />
          {this._SpaceBox()}
          <input
            id={`sRoad_${key}`}
            type="text"
            className="form-control"
            placeholder={this._getLang("road")}
            name="sRoad"
            value={sRoad}
            onChange={(e) =>
              onChangeModel({ key, name: e.target.name, value: e.target.value })
            }
          />
        </div>
        <ProvincesComponent
          lang={lang}
          langague={Step3Langague}
          provinces={{ sProvince, sDistrict, sCity, sZipcode }}
          onChange={(object) =>
            onChangeModelProvinces({ key, addressChange: object })
          }
        />
      </>
    );
  }

  _renderRadioAddress = (key) => {
    const { insures, onChangeModel, onChangeAddressOther } =
      this.context.step3 || {};
    const { isSameIdentity } = insures[key];

    const onChange = (value) => {
      onChangeModel({ key, name: "isSameIdentity", value: value });
      onChangeAddressOther({ key });
    };

    return (
      <>
        <div className="form-group">
          <div
            className={`address-radio radio-button align-item-center w-100 ${
              isSameIdentity === 1 ? "active" : ""
              }`}
            onClick={() => onChange(1)}
          >
            <div className="radio" />
            <p>ที่อยู่เดียวกับคนที่ 1</p>
          </div>
        </div>
        <div className="form-group">
          <div
            className={`address-radio radio-button align-item-center w-100 ${
              isSameIdentity === 2 ? "active" : ""
              }`}
            onClick={() => onChange(2)}
          >
            <div className="radio" />
            <p>ที่อยู่อื่นๆ (ระบุ)</p>
          </div>
        </div>
      </>
    );
  };

  _renderPersonalBenefit(insure, key, person, index) {
    const { benefitTitles, benefitTitlesEN } = this.state;
    const { onChangeBenefit } = this.context.step3 || {};
    const { sInit, sFirstName, sLastName, sRelation } = person;
    const { sNationality } = insure;
    const isThai = sNationality && sNationality.value === "THA";
    const lang = isThai ? 'th' : 'en';
    return (
      <>
        <div className="form-group">
          <label>{this.context.step1.langague === 2 
                  ? "Name/Surname" 
                  : "ชื่อ/นามสกุล"}</label>
          <SelectComponent
            placeholder={this._getLang("initName", lang)}
            options={this.context.step1.langague === 1 ? benefitTitles : benefitTitlesEN}
            selected={sInit}
            onChange={(selected) =>
              onChangeBenefit({ key, index, name: "sInit", value: selected })
            }
          />
          <input
            id={`sFirstName_${key}_${index}}`}
            type="text"
            className="form-control mt-2"
            placeholder={this._getLang("firstName", lang)}
            name="sFirstName"
            value={sFirstName}
            onChange={(e) =>
              onChangeBenefit({
                key,
                index,
                name: e.target.name,
                value: e.target.value,
              })
            }
          />
          <input
            id={`sLastName_${key}_${index}`}
            type="text"
            className="form-control mt-2"
            placeholder={this._getLang("lastName", lang)}
            name="sLastName"
            value={sLastName}
            onChange={(e) =>
              onChangeBenefit({
                key,
                index,
                name: e.target.name,
                value: e.target.value,
              })
            }
          />
        </div>
        <div className="form-group">
          <label>{this._getLang("relation", lang)}</label>
          <SelectComponent
            placeholder={this._getLang("pleaseChooseUpper", lang)}
            options={this.context.step1.langague === 1 ? RELATIONS : RELATIONS_EN}
            selected={sRelation}
            onChange={(selected) =>
              onChangeBenefit({
                key,
                index,
                name: "sRelation",
                value: selected,
              })
            }
          />
        </div>
      </>
    );
  }

  _SpaceBox() {
    return <SpaceBox w={"14px"} />;
  }

  
  render() {
    
    const { insures, onAddBenefit, onRemoveBenefit } = this.context.step3 || {};
    const { editKey } = this.context.step4;
    const defaultKey = editKey == 0 ? 0 : (editKey || 0);

    return (
      <div className="form-wrapper">
        <Accordion defaultActiveKey={defaultKey + 1} className="accordion-wrapper">
          {insures &&
            insures.map((insure, index) => {
              const isOtherAddress = index > 0 && insure.isSameIdentity == 2;
              const benefitCount =
                insure && insure.benefits ? insure.benefits.length : 1;

              return (
                <Card className="accordion-item" key={index + 1}>
                  <Accordion.Toggle as={Card.Header} eventKey={index + 1}>
                    <div className="d-flex align-item-center">
                      <Icon src={UserIcon} />
                      <p className="header-accordion-text">
                      {this.context.step1.langague === 2 ? "Insured Person " + (index + 1) : "ผู้เอาประกันภัยคนที่ " + (index + 1)}
                      </p>
                      <Icon className="ml-auto" src={ChevonDown} />
                    </div>
                  </Accordion.Toggle>
                  <Accordion.Collapse eventKey={index + 1}>
                    <Card.Body className="accordion-body">
                      <div className="form-wrapper">
                        {this._renderPresonForm(index)}
                      </div>
                      <div className="form-group address-header">
                        <label>{this._getLang("address")}</label>
                      </div>
                      <div className="form-wrapper">
                        {index == 0 ? (
                          this._renderAddressForm(index)
                        ) : (
                            <Fragment>
                              {this._renderRadioAddress(index)}
                              {isOtherAddress && this._renderAddressForm(index)}
                            </Fragment>
                          )}
                      </div>
                      {/* Benefit Section */}
                      {insure &&
                        insure.benefits &&
                        insure.benefits.map((person, indexIn) => {
                          return (
                            <Fragment key={indexIn}>
                              <div className="form-group address-header">
                                <label>{this.context.step1.langague === 2 ? "Beneficiary " + (index + 1) : "ผู้รับประโยชน์ " + (index + 1)}</label>
                              </div>
                              <div className="form-wrapper">
                                {this._renderPersonalBenefit(
                                  insure,
                                  index,
                                  person,
                                  indexIn
                                )}
                              </div>
                            </Fragment>
                          );
                        })}
                      <div className="form-group benefit-wrapper">
                        {benefitCount === 1 ? (
                          <button
                            className="btn btn-seconday m-auto d-flex"
                            onClick={() => onAddBenefit(index)}
                          >
                            <p>{this.context.step1.langague === 2 ? "Add Beneficiary" : "เพิ่มผู้รับประโยชน์"}</p>{" "}
                            <img src={AddRound} width="24px" height="24px" />
                          </button>
                        ) : benefitCount === 2 ? (
                          <button
                            className="btn btn-seconday m-auto d-flex"
                            onClick={() => onRemoveBenefit(index)}
                          >
                            <p>{this.context.step1.langague === 2 ? "Remeove Beneficiary" : "ลบผู้รับประโยชน์"}</p>{" "}
                            <img src={DelRound} width="24px" height="24px" />
                          </button>
                        ) : (
                              ""
                            )}
                      </div>
                    </Card.Body>
                  </Accordion.Collapse>
                </Card>
              );
            })}
        </Accordion>
      </div>
    )
  }
}

Step3.contextType = TaContext;
export default withRouter(Step3);